module.exports = __webpack_public_path__ + "assets/img/Pioneer_Chassard_001.35854b62-ps.jpg";